import { useState } from "react";
import { api } from "@shared/api/client";
import type { CalidadControlModificacion, CalidadControlModificacionPayload } from "../../types/control-modificaciones";
import { CalidadControlModificacionDeleteModal } from "./CalidadControlModificacionDeleteModal";
import { CalidadControlModificacionFormModal } from "./CalidadControlModificacionFormModal";
import { CalidadControlModificacionesTable } from "./CalidadControlModificacionesTable";
import { getCertificationRequestError } from "../shared/request";

type Props = { rows: CalidadControlModificacion[]; loading: boolean; error: string | null; baseEndpoint: string; onReload: () => Promise<void> | void };

export function CalidadControlDocumentalPanel({ rows, loading, error, baseEndpoint, onReload }: Props) {
  const [form, setForm] = useState<{ open: boolean; row: CalidadControlModificacion | null }>({ open: false, row: null });
  const [deleteRow, setDeleteRow] = useState<CalidadControlModificacion | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [formError, setFormError] = useState<string | null>(null);

  const submit = async (payload: CalidadControlModificacionPayload) => {
    setSubmitting(true); setFormError(null);
    try {
      if (form.row) await api.put(`${baseEndpoint}/${form.row.id}`, payload);
      else await api.post(baseEndpoint, payload);
      setForm({ open: false, row: null });
      await onReload();
    } catch (requestError) {
      setFormError(getCertificationRequestError(requestError, "No se pudo guardar la modificación."));
    } finally { setSubmitting(false); }
  };

  const remove = async () => {
    if (!deleteRow) return;
    setSubmitting(true);
    try { await api.delete(`${baseEndpoint}/${deleteRow.id}`); setDeleteRow(null); await onReload(); }
    finally { setSubmitting(false); }
  };

  return <>
    <CalidadControlModificacionesTable rows={rows} loading={loading} error={error} onRetry={() => void onReload()} onCreate={() => setForm({ open: true, row: null })} onEdit={(row) => setForm({ open: true, row })} onDelete={setDeleteRow} />
    <CalidadControlModificacionFormModal open={form.open} mode={form.row ? "edit" : "create"} initialValues={form.row} submitting={submitting} error={formError} onClose={() => setForm({ open: false, row: null })} onSubmit={(payload) => void submit(payload)} />
    <CalidadControlModificacionDeleteModal open={deleteRow !== null} title="Eliminar modificación" description={deleteRow ? `Se eliminará la modificación registrada en ${deleteRow.fecha}.` : ""} deleting={submitting} onClose={() => setDeleteRow(null)} onConfirm={() => void remove()} />
  </>;
}
